export default "__VITE_ASSET__C674zLrM__"